export default __webpack_public_path__ + "static/media/pin_spot.8a3c34df.svg";